import { Component, OnInit, Injector, inject } from '@angular/core';
import { LoginCoreComponent } from './loginCore.component';
import { FormsModule } from '@angular/forms';
import { CapsLockComponent } from '../../components/Controls/caps-lock/caps-lock.component';
import { RouterLink } from '@angular/router';
import { NWMTfaComponent } from '../../components/Controls/tfa/tfa.component';
import { AwardsComponent } from '../../components/Controls/awards/awards.component';

@Component({
    templateUrl: './login.component.html',
    imports: [FormsModule, CapsLockComponent, RouterLink, NWMTfaComponent, AwardsComponent]
})

export class LoginComponent extends LoginCoreComponent implements OnInit {

  public accessType: string = 'client';

  constructor() {
    const injector = inject<Injector>(Injector);

    super(injector);
  }

  ngOnInit() {
    if (this.auth.isLoggedIn) { this.auth.logUserOut(); }
    this.accessType = 'client';
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
    this.sessionTimedOut = this.route.snapshot.params['code'] === 'sessionTimeout';

    sessionStorage.removeItem('isKYCredirect');
    sessionStorage.removeItem('guid');
    if (this.route.snapshot.params['code']?.toLowerCase() === 'kyc') {
      sessionStorage.setItem('isKYCredirect', '1');
    } else if (this.route.snapshot.params['code']) {
      if (this.route.snapshot.params['code'] === 'accountant') {
        this.accessType = 'accountant';
      }
      else if (this.route.snapshot.params['code'] !== 'sessionTimeout') {
        // C360 impersonation
        this.post(this.config.login.loginC360, {accesstoken: this.route.snapshot.params['code']}, (data) => {
          if (data && Object.prototype.hasOwnProperty.call(data, 'token_type')) {
            sessionStorage.setItem('guid', this.route.snapshot.params['code']);
          }
        });
      }
    }
  }

  login() {
    this.sessionTimedOut = false;
    this.errorMsg = '';
    const body = {
      'username': this.username,
      'password': this.password,
      'release': this.config.releaseVersion,
      'trustedComputer': localStorage.getItem('trustedComputer_' + this.username.toLowerCase().trim())
    };
    this.post(this.config.login.loginUrl, body); // see LoginCoreComponent.post for details - everythig's processed there
  }

}
